import { useEffect, useState } from "react";

export function useLocation() {
  const [location, setLocation] = useState<GeolocationPosition | null>(null);
  const [locationPermission, setLocationPermission] =
    useState<"granted" | "denied" | "prompt">("denied");

  const handleLocationRequest = async () => {
    const options = {
      enableHighAccuracy: false,
      timeout: 5000,
    };

    const success = (pos: any) => {
      const crd = pos.coords;
      setLocation(pos);

      console.log(
        `✅ Your current position is: Latitude: ${crd.latitude}, Longitude: ${crd.longitude} with more or less ${crd.accuracy} meters.`
      );
    };

    const error = (err: { code: any; message: any }) => {
      console.log(`🟡 ERROR(${err.code}): ${err.message}`);
      // TODO: show error in snackbar for user
    };
    navigator.geolocation.watchPosition(success, error, options);
  };

  const checkLocationPermission = async () => {
    // Check if Permissions API is supported
    if ("permissions" in navigator) {
      try {
        const result = await navigator.permissions.query({
          name: "geolocation",
        });
        setLocationPermission(result.state);

        // Set up listener for permission changes
        result.onchange = () => {
          setLocationPermission(result.state);
          if (result.state === "granted") {
            handleLocationRequest();
          }
        };

        if (result.state === "granted") {
          handleLocationRequest();
        }
      } catch (error) {
        console.warn("Permissions API not supported:", error);
        // Fallback to directly requesting location
        handleLocationRequest();
      }
    } else {
      // If Permissions API is not supported, directly request location
      console.warn("Permissions API not supported in this browser");
      handleLocationRequest();
    }
  };

  useEffect(() => {
    checkLocationPermission();
  }, []);

  return { location, locationPermission };
}
